import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import NavigationBreadcrumbs from '../../components/ui/NavigationBreadcrumbs';
import Button from '../../components/ui/Button';
import Icon from '../../components/AppIcon';

const RegistrationPendingVerification = () => {
  const navigate = useNavigate();
  const [user] = useState({
    id: 1,
    name: "Usuario Pendiente",
    email: "usuario@email.com",
    type: "user"
  });

  const handleContactSupport = () => {
    window.open('https://wa.me/573152495959', '_blank');
  };

  const handleGoToLogin = () => {
    navigate('/user-login');
  };

  return (
    <div className="min-h-screen bg-background">
      <Header user={user} />
      <NavigationBreadcrumbs />
      
      <main className="main-content pb-12">
        <div className="max-w-3xl mx-auto">
          <div className="mb-8 text-center">
            <div className="flex justify-center mb-4">
              <div className="bg-gradient-to-r from-primary/20 to-accent/20 rounded-full p-6">
                <Icon name="Clock" size={64} className="text-primary" />
              </div>
            </div>
            <h1 className="text-3xl font-bold text-foreground mb-2">
              ¡Registro Completado!
            </h1>
            <p className="text-muted-foreground text-lg">
              Tu solicitud está siendo revisada por nuestro equipo
            </p>
          </div>

          <div className="space-y-6">
            {/* Main Status Card */}
            <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border-2 border-blue-200 rounded-xl p-8">
              <div className="text-center space-y-4">
                <div className="flex justify-center">
                  <div className="bg-blue-100 rounded-full p-4">
                    <Icon name="FileCheck" size={48} className="text-blue-600" />
                  </div>
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-blue-900 mb-3">
                    Verificación Manual en Proceso
                  </h2>
                  <p className="text-blue-800 text-lg leading-relaxed">
                    Tu registro ha sido recibido exitosamente. Nuestro equipo está revisando tu información, 
                    el plan seleccionado y el comprobante de pago para activar tu cuenta.
                  </p>
                </div>
              </div>
            </div>

            {/* Timeline Information */}
            <div className="bg-card rounded-lg border shadow-sm p-6">
              <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center gap-2">
                <Icon name="Clock" size={20} className="text-primary" />
                Tiempo Estimado de Verificación
              </h3>
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <div className="bg-yellow-100 rounded-full p-2 mt-1">
                    <Icon name="AlertCircle" size={20} className="text-yellow-600" />
                  </div>
                  <div className="flex-1">
                    <p className="font-semibold text-foreground mb-1">Proceso de Revisión: 24 horas</p>
                    <p className="text-sm text-muted-foreground">
                      Nuestro equipo verificará manualmente todos los datos proporcionados, incluyendo:
                    </p>
                    <ul className="text-sm text-muted-foreground mt-2 space-y-1 ml-4">
                      <li className="flex items-center gap-2">
                        <Icon name="Check" size={14} className="text-primary" />
                        Información personal y de contacto
                      </li>
                      <li className="flex items-center gap-2">
                        <Icon name="Check" size={14} className="text-primary" />
                        Plan de membresía seleccionado
                      </li>
                      <li className="flex items-center gap-2">
                        <Icon name="Check" size={14} className="text-primary" />
                        Comprobante de pago y transacción
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* What Happens Next */}
            <div className="bg-card rounded-lg border shadow-sm p-6">
              <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center gap-2">
                <Icon name="CheckCircle" size={20} className="text-green-600" />
                ¿Qué Sucede Después?
              </h3>
              <div className="space-y-3">
                <div className="flex items-start gap-3 p-3 bg-green-50 rounded-lg">
                  <Icon name="Mail" size={20} className="text-green-600 mt-0.5 flex-shrink-0" />
                  <div>
                    <p className="font-semibold text-green-900 mb-1">Notificación por Correo</p>
                    <p className="text-sm text-green-800">
                      Te enviaremos un correo electrónico cuando tu cuenta sea activada
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3 p-3 bg-blue-50 rounded-lg">
                  <Icon name="Key" size={20} className="text-blue-600 mt-0.5 flex-shrink-0" />
                  <div>
                    <p className="font-semibold text-blue-900 mb-1">Acceso a tu Cuenta</p>
                    <p className="text-sm text-blue-800">
                      Una vez activada, podrás iniciar sesión con tus credenciales y acceder al panel de usuario
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3 p-3 bg-purple-50 rounded-lg">
                  <Icon name="Gift" size={20} className="text-purple-600 mt-0.5 flex-shrink-0" />
                  <div>
                    <p className="font-semibold text-purple-900 mb-1">Beneficios Activos</p>
                    <p className="text-sm text-purple-800">
                      Disfrutarás de todos los beneficios de tu plan de membresía inmediatamente
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Important Notice */}
            <div className="bg-yellow-50 border-2 border-yellow-200 rounded-xl p-6">
              <div className="flex items-start gap-3">
                <Icon name="Info" size={24} className="text-yellow-600 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="font-semibold text-yellow-900 mb-2">Información Importante</p>
                  <ul className="text-sm text-yellow-800 space-y-2">
                    <li className="flex items-start gap-2">
                      <span className="font-bold mt-0.5">•</span>
                      <span>Si intentas iniciar sesión antes de la activación, verás esta misma pantalla</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="font-bold mt-0.5">•</span>
                      <span>No es necesario crear una nueva cuenta, solo espera la activación</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="font-bold mt-0.5">•</span>
                      <span>Revisa tu bandeja de entrada y carpeta de spam para no perder nuestra notificación</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Contact Support */}
            <div className="bg-card rounded-lg border shadow-sm p-6">
              <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center gap-2">
                <Icon name="HelpCircle" size={20} className="text-primary" />
                ¿Necesitas Ayuda?
              </h3>
              <p className="text-muted-foreground mb-4">
                Si tienes alguna pregunta o necesitas asistencia durante el proceso de verificación, 
                nuestro equipo de soporte está disponible para ayudarte.
              </p>
              <div className="flex flex-col sm:flex-row gap-3">
                <Button 
                  onClick={handleContactSupport}
                  variant="default"
                  className="flex-1"
                  iconName="MessageCircle"
                  iconPosition="left"
                >
                  Contactar Soporte
                </Button>
                <Button 
                  onClick={handleGoToLogin}
                  variant="outline"
                  className="flex-1"
                  iconName="LogIn"
                  iconPosition="left"
                >
                  Ir a Inicio de Sesión
                </Button>
              </div>
              <div className="mt-4 pt-4 border-t">
                <p className="text-sm text-muted-foreground text-center">
                  <Icon name="Phone" size={14} className="inline mr-1" />
                  WhatsApp: +57 315 249 5959
                  <span className="mx-2">|</span>
                  <Icon name="Mail" size={14} className="inline mr-1" />
                  bizznet.latam@gmail.com
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default RegistrationPendingVerification;